import { FC, PropsWithChildren } from 'react';
import { CatListItem } from '@blocks-react/components/ListItem';
import { CatCheckboxField } from '@blocks-react/components/CheckboxField';
import { BlocksCheckboxChangeEvent } from '@blocks-web-components/events';
import styles from './styles.module.scss';
import cx from 'classnames';

interface ListMenuItemProps {
  item: {
    id: string;
    name: string;
    checked?: boolean;
    count?: string;
  };
  handleItemClick: (e: BlocksCheckboxChangeEvent | string) => void;
  className?: string;
}

export const ListMenuItem: FC<PropsWithChildren<ListMenuItemProps>> = ({
  handleItemClick,
  item,
  className
}) => {
  const shouldDisableFacet = !Number(item.count);
  return (
    <CatListItem
      key={item.id}
      data-testid="list-menu-item-checkbox"
      value={item.id}
      isStatic={shouldDisableFacet}
      className={className}
    >
      <CatCheckboxField
        onBlCheckboxChange={(e) => handleItemClick(e)}
        checked={item.checked}
        disabled={shouldDisableFacet}
        value={item.id}
        role="menuitemcheckbox"
        data-testid="list-menu-item"
        className={cx({
          [styles['list-menu-item-checkbox']]: shouldDisableFacet
        })}
      >
        {item.name}
      </CatCheckboxField>
    </CatListItem>
  );
};
